
export class MunicipioModel {

    public unidadeFederacaoId: string;
    public municipioId: number;
    public codigoComarca: number;
    public nomeResumido: string;
    public dataAtualizacao: string;
    public statusMunicipioCEP: boolean;
    public codigoMunicipioIBGE: number;
    public codigoMicroRregiaoEstado: number;
    public codigoMunicipioSRF: number;
    public cnpjBaseMunicipio: number;
    public cnpjFilialMunicipio: number;
    public cnpjDigitoMunicipio: number;
    public statusCobrancaTaxaIncendio: number;

    constructor(public nome: string) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/municipio.model.ts